import styled from "styled-components/macro";
import React, { useEffect, useState } from "react";
import { ReactComponent as DitoIcon } from "../assets/dito_icon.svg";
import {
  MdAdd,
  MdArrowForwardIos,
  MdBookmark,
  MdBookmarkBorder,
  MdCheckCircle,
  MdCloud,
  MdFolder,
  MdMenu,
  MdOutlineShoppingCart,
  MdPerson,
  MdPersonOutline,
  MdShoppingCart,
} from "react-icons/md";

import "../styles/Home.css";
import Spinner from "../components/Spinner";
import { useNavigate } from "react-router";
import { isEmpty } from "../functions/isEmpty";

export default function Home({
  apiURL,
  isMobile,
  chats,
  scrollPositionHome,
  setScrollPositionHome,
  user,
  searchString,
  setSearchString,
  setActiveOperator,
  activeOperator,
  documents,
  operators,
  messages,
  setActiveContact,
}) {
  const [sortedOperators, setSortedOperators] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  let navigate = useNavigate();

  const handleClick = (operator) => {
    setActiveOperator(operator);
    if (!isEmpty(operator.navigation_id)) {
      navigate("/chats/" + operator.navigation_id);
    } else {
      navigate("/chats/0");
    }
  };

  useEffect(() => {
    if (isEmpty(user)) {
      navigate("/login");
    }
    setActiveContact(null);
  }, [user]);

  useEffect(() => {
    const newSortedOperators = operators.map((operator) => {
      const relatedChat = chats.find(
        (chat) => chat.operators_id === operator.id
      );
      const navigation_id = relatedChat?.id || null;

      const relatedMessages = navigation_id
        ? messages.filter((msg) => msg.chats_id === navigation_id)
        : [];

      const messagesNotSeen = relatedMessages.reduce((count, msg) => {
        return count + (msg.seen === 0 || msg.seen === "0" ? 1 : 0);
      }, 0);

      const lastMessage = relatedMessages.reduce((latest, msg) => {
        return !latest || msg.createdAt > latest.createdAt ? msg : latest;
      }, null);

      return {
        ...operator,
        navigation_id,
        messagesNotSeen,
        lastMessage,
      };
    });

    newSortedOperators.sort((a, b) => {
      const aTime = a.lastMessage?.createdAt ?? null;
      const bTime = b.lastMessage?.createdAt ?? null;

      if (aTime === null && bTime === null) return 0;
      if (aTime === null) return 1; // a kommt nach b
      if (bTime === null) return -1; // b kommt nach a
      return bTime - aTime; // absteigend
    });

    setSortedOperators(newSortedOperators);
  }, [operators, chats, messages]);

  function formatTimestamp(unixTimestamp) {
    // Überprüfe, ob der Timestamp eine gültige Zahl ist
    if (isNaN(unixTimestamp)) {
      return "";
    }

    const date = new Date(unixTimestamp * 1000); // Unix-Timestamp in Sekunden
    const now = new Date();

    // Prüfe, ob das Datum vom heutigen Tag ist
    if (date.toDateString() === now.toDateString()) {
      // Formatierung: hh:mm
      const hours = date.getHours().toString().padStart(2, "0");
      const minutes = date.getMinutes().toString().padStart(2, "0");
      return `${hours}:${minutes}`;
    }

    // Berechne den Unterschied in Tagen
    const startOfToday = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate()
    );
    const startOfDate = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate()
    );
    const diffTime = startOfToday - startOfDate;
    const diffDays = diffTime / (1000 * 60 * 60 * 24);

    // Wenn genau 1 Tag Unterschied: "gestern"
    if (diffDays === 1) {
      return "Gestern";
    }

    // Liegt die Nachricht zwischen 1 und 6 Tagen zurück?
    if (diffDays < 7) {
      // Deutscher Wochentag
      const weekdays = [
        "Sonntag",
        "Montag",
        "Dienstag",
        "Mittwoch",
        "Donnerstag",
        "Freitag",
        "Samstag",
      ];
      return weekdays[date.getDay()];
    } else {
      // Mehr als 7 Tage zurück: Format dd.mm.yy
      const day = date.getDate().toString().padStart(2, "0");
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const year = date.getFullYear().toString().slice(-2);
      return `${day}.${month}.${year}`;
    }
  }

  let demo = [
    {
      id: 1,
      img_url:
        "https://www.cloud.ditochat.com/api/images/placeholder/ditochat_home_logo.png",
      title: "Instagram Posts entwerfen",
      description:
        "Entwirft Instagram Beiträge mit Bildern und Texten nach deinen Vorgaben",
      setup: 0,
      category: "Instagram",
    },
    {
      id: 2,
      img_url:
        "https://www.cloud.ditochat.com/api/images/placeholder/ditochat_home_logo.png",
      title: "Instagram Posts teilen",
      description: "Teilt Instagram Beiträge",
      setup: 0,
      category: "Instagram",
    },
    {
      id: 3,
      img_url:
        "https://www.cloud.ditochat.com/api/images/placeholder/ditochat_home_logo.png",
      title: "Kommentare Antworten entwerfen",
      description: "Schreibt Antworten auf Instagram Kommentar",
      setup: 0,
      category: "Instagram",
    },
    {
      id: 4,
      img_url:
        "https://www.cloud.ditochat.com/api/images/placeholder/ditochat_home_logo.png",
      title: "Email Antworten entwerfen",
      description: "Schreibt Antworten auf Emails",
      setup: 1,
      category: "Email",
    },
  ];

  console.log(
    JSON.stringify([
      {
        id: 1,
        title: "Instagram Posts entwerfen",
        if_data_is_given: "Thema und Anzahl an zu planenden Posts",
        then_add_to_answer:
          'Finde Thema und Anzahl an zu plandenen Posts heraus und gib dann folgendes exakt so zurück – inklusive der Sternchen, mit gültigem JSON und geraden Anführungszeichen:\n\n**start systemmessage**\n{\n  "command": "createInstagramPosts",\n  "topic": "*topic*",\n  "number_count_of_posts": "*number_count_of_posts*"\n}\n**end systemmessage**',
      },
    ])
  );

  return (
    <div className="home">
      <div className="home_topnav">
        <div className="home_topnav_logo">
          <img
            src="https://www.cloud.ditochat.com/api/images/placeholder/ditochat_home_logo.png"
            className="home_topnav_logo_img"
          />
        </div>
        <div className="home_topnav_menubtn" onClick={() => navigate("/menu")}>
          <MenuIcon />
        </div>
      </div>
      <div className="home_body">
        <div
          style={{
            padding: "14px",
            fontWeight: 600,
            borderBottom: "1px solid #ebebeb",
          }}>
          Instagram
        </div>
        {operators.map((dem, index) => (
          <>
            {dem.category == "Instagram" && (
              <div
                className="home_body_element"
                key={"homelist" + index}
                onClick={() => handleClick(dem)}>
                <div className="home_body_element_left">
                  {/*
                                             <DitoIconStyled />
              */}
                  <img
                    src={dem.img_url}
                    className="home_body_element_left_img"
                  />
                </div>
                <div className="home_body_element_right">
                  <div className="home_body_element_right_top">
                    <div className="home_body_element_right_top_text">
                      {dem.name}
                    </div>
                    {/*
               <div className="home_body_element_right_top_time">11:35</div>
               */}
                    <div className="home_body_element_right_top_time">
                      {dem.setup == 1 ? <CheckIcon /> : <ArrowForwardIcon />}
                    </div>
                  </div>
                  <div className="home_body_element_right_bottom">
                    <div className="home_body_element_right_bottom_text">
                      {dem.description}
                    </div>
                    <div className="home_body_element_right_bottom_icon"></div>
                  </div>
                </div>
              </div>
            )}
          </>
        ))}
        <div
          style={{
            padding: "14px",
            fontWeight: 600,
            borderBottom: "1px solid #ebebeb",
          }}>
          Email
        </div>
        {operators.map((dem, index) => (
          <>
            {dem.category == "Email" && (
              <div
                className="home_body_element"
                key={"homelist" + index}
                onClick={() => handleClick(dem)}>
                <div className="home_body_element_left">
                  {/*
                           
 <DitoIconStyled />
              */}
                  <img
                    src={dem.img_url}
                    className="home_body_element_left_img"
                  />
                </div>
                <div className="home_body_element_right">
                  <div className="home_body_element_right_top">
                    <div className="home_body_element_right_top_text">
                      {dem.name}
                    </div>
                    {/*
               <div className="home_body_element_right_top_time">11:35</div>
               */}
                    <div className="home_body_element_right_top_time">
                      {dem.setup == 1 ? <CheckIcon /> : <ArrowForwardIcon />}
                    </div>
                  </div>
                  <div className="home_body_element_right_bottom">
                    <div className="home_body_element_right_bottom_text">
                      {dem.description}
                    </div>
                    <div className="home_body_element_right_bottom_icon"></div>
                  </div>
                </div>
              </div>
            )}
          </>
        ))}
      </div>
    </div>
  );
}

const DitoIconStyled = styled(DitoIcon)`
  width: 40px;
  height: 40px;
  color: #717171;
`;

const MenuIcon = styled(MdMenu)`
  font-size: 30px;
  color: #474747;
`;

const ArrowForwardIcon = styled(MdArrowForwardIos)`
  font-size: 15x;
  color: #bababa;
`;

const CloudIcon = styled(MdFolder)`
  font-size: 18px;
  color: #474747;
`;

const CheckIcon = styled(MdCheckCircle)`
  font-size: 25px;
  color: #ee3a95;
  margin-bottom: -5px;
`;

const AddIcon = styled(MdAdd)`
  font-size: 23px;
  color: #0072f5;
`;

const FolderIcon = styled(MdFolder)`
  font-size: 23px;
  color: rgb(114, 114, 114);
`;

const AccountIcon = styled(MdPerson)`
  font-size: 23px;
  color: rgb(114, 114, 114);
`;
